import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'components';
import './Tabs.scss';

export default class Tabs extends React.Component {
  constructor(props) {
    super(props);
    const { setActiveTab } = this.props;
    this.state = {
      activeTab: setActiveTab,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(tab) {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const { activeTab } = this.state;
    const {
      border,
      className,
      content,
      justify,
      showButtons,
      stickyNav,
    } = this.props;
    const borderClass = {
      default: '',
      bottom: 'bordered-bottom',
      top: 'bordered-top',
    };

    return (
      <div
        className={classnames(
          'tabs',
          { 'nav-justified': justify },
          borderClass[border],
          className
        )}
      >
        <div>
          <Nav
            tabs
            className={classnames({
              'sticky-nav': stickyNav,
            })}
          >
            {content.map((item, index) => (
              <NavItem key={`${item.tabName + index}.link`}>
                <NavLink
                  className={classnames({
                    active: activeTab === index,
                  })}
                  onClick={() => {
                    this.toggle(index);
                  }}
                  tag="button"
                  type="button"
                >
                  {item.tabName}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={activeTab}>
            {content.map((item, index) => (
              <TabPane key={`${item.tabName + index}.content`} tabId={index}>
                {!item.renderIfActiveOnly || activeTab === index
                  ? item.tabContent
                  : null}
              </TabPane>
            ))}
          </TabContent>
        </div>
        {showButtons && (
          <div className="tab-buttons">
            <div>
              <Button
                color="secondary"
                disabled={activeTab === 0}
                onClick={() => {
                  this.toggle(activeTab - 1);
                  document.activeElement.blur();
                }}
                className={`${activeTab === 0 ? 'd-none' : ''}`}
              >
                Previous
              </Button>
            </div>
            <div>
              <Button
                color="primary"
                disabled={activeTab === content.length - 1}
                onClick={() => {
                  this.toggle(activeTab + 1);
                  document.activeElement.blur();
                }}
                className={`${
                  activeTab === content.length - 1 ? 'd-none' : ''
                }`}
              >
                Next
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Tabs.propTypes = {
  setActiveTab: PropTypes.number,
  border: PropTypes.oneOf(['default', 'top', 'bottom']),
  className: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string,
      tabContent: PropTypes.node,
      renderIfActiveOnly: PropTypes.bool,
    })
  ).isRequired,
  justify: PropTypes.bool,
  showButtons: PropTypes.bool,
  stickyNav: PropTypes.bool,
};

Tabs.defaultProps = {
  setActiveTab: 0,
  className: '',
  border: 'top',
  justify: true,
  showButtons: false,
  stickyNav: false,
};
